import {FeatureAppConfig} from '../typing/main';
import {useFeatureAppEnvironment} from './use-feature-app-environment';

export function useFeatureAppConfig(): FeatureAppConfig {
  const {config = {},featureServices} = useFeatureAppEnvironment();
  const { configs } =featureServices['service-config-provider'];
  let faServicesUrl =  config.faServicesUrl;
  let trimNamesMap = config.trimNamesMap;
  if(!faServicesUrl) faServicesUrl = configs['fa-services']?.urlOrigin;
  if (!trimNamesMap) trimNamesMap = configs['offers-config']?.customConfig ? (configs['offers-config']?.customConfig as any)?.mappedTrimName : {}
  return {...config, faServicesUrl, trimNamesMap};
}
